
import { footer, seo } from '../customWhiteLabel'
export default {
  data() {
    return {
      footer,
      seo,
    }
  },
  computed: {
    buttonPosition() {
      if (this.$route.fullPath === '/compra-pedido') {
        return 'left'
      } else {
        return 'right'
      }
    },
  },
  methods: {
    sendMessage() {
      const phoneNumber = footer.botaoWhatsapp
      const message = `Olá, estou no site certificadorapadrao.com.br e gostaria de saber mais`
      const whatsappUrl = `https://wa.me/55${phoneNumber}?text=${encodeURIComponent(
        message
      )}`
      window.open(whatsappUrl, '_blank')
    },
  },
}
